import { IStyle, makeStyles } from '@fluentui/react-theme-provider';

export const useErrorComponentStyles = () => {
  const container: IStyle = {
    marginTop: 24,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  const descContainer: IStyle = {
    marginBottom: 39,
    fontSize: 14,
    textAlign: 'center',
  };

  const titleContainer: IStyle = {
    marginBottom: 8,
    fontSize: 18,
  };

  return makeStyles({
    container,
    descContainer,
    titleContainer,
  })();
};
